import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function SubLink({text ,route}) {
    let navigate = useNavigate()
  return (
    <a onClick={() =>navigate(route ? route : -1)} className="title1">{text}</a>
  )
}
